module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "SubscriptionInvitation", "Pending Invitations from %s".format(owner) ) ))==null?'':__t)+
' </legend><p> '+
((__t=( i18n.tc("SubscriptionInvitation", "Please accept or reject the following invitations. By accepting an invitation you will get access to the associated device.") ))==null?'':__t)+
'</p></fieldset><div data-region="invitation-subscriptions-container"></div>';
}
return __p;
};
